import { useLocation } from 'react-router';
import { TrackingDetails } from './types';

// for sonarqube
const TEAMS_SUMMARY = 'pricing-teams-summary';
/**
 * We need to send exactly what is sent in prod now so we do not mess up existing dashboards.
 * For now, details & summary will suffice (we do not track enterprise page).
 * Do not change the object mapping without approval
 */
const PAGE_NAME_MAP: Record<string, string> = Object.freeze({
  'plans-and-pricing': 'pricing summary canonical',
  'plans-and-pricing-teams': 'pricing summary teams',
  'plans-and-pricing-individual': 'pricing summary individual',
  'plans-and-pricing-details': 'pricing details canonical',
  'plans-and-pricing-teams-details': 'pricing details teams',
  'plans-and-pricing-individual-details': 'pricing details individual',
  'plans-and-pricing-educational': 'pricing educational',
});

/**
 * Similar to the above, a map of generated page names to the ut_source
 * parameter that will be attached to outgoing links
 */
const UT_SOURCE_MAP: Record<string, string> = Object.freeze({
  'plans-and-pricing': TEAMS_SUMMARY,
  'plans-and-pricing-teams': TEAMS_SUMMARY,
  'plans-and-pricing-details': 'pricing-teams-details',
  'plans-and-pricing-individual': 'pricing-indv-summary',
  'plans-and-pricing-teams-details': 'pricing-teams-details',
  'plans-and-pricing-individual-details': 'pricing-indv-details',
  'plans-and-pricing-educational': 'pricing-indv-details',
  'plans-and-pricing-enterprise': TEAMS_SUMMARY, // for now we are replicating legacy billweb
  'plans-and-pricing-enterprise-details': TEAMS_SUMMARY,
});

/**
 * This hook returns the tracking info we need for either @sm/metrics or amplitude.
 * This hook can be extended to support all required tracking information in the near future
 * If display name is not provided, we fall back to the route.
 * @returns TrackingDetails
 */
export default function useTrackingDetails(): TrackingDetails {
  const { pathname, search } = useLocation();
  const utSource = new URLSearchParams(search).get('ut_source');
  // strips and replaces beginning and ending forward slash in the pathname
  const pageName = pathname
    ?.replace(/\//g, '-')
    .replace(/^\W+|\W+$/gm, '')
    .trim();

  return {
    utSource,
    pageName: PAGE_NAME_MAP[pageName],
    pageUtSource: UT_SOURCE_MAP[pageName],
  };
}
